/*
 * @Author: your name
 * @Date: 2020-07-24 15:29:07
 * @LastEditTime: 2021-03-04 16:24:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/api/app-page/index.js
 */
export default {
  module: 'APP_PAGE',
  QUERY_FORM_TABS: {
    url: '/xdap-app/form/query/listPageViewIdsByFormId',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_LIST_PAGE_CONFIG_BY_ID: {
    url: '/xdap-app/form/query/mobileListComponent',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_LIST_BUSINESS_DATA: {
    url: '/xdap-app/business/query/listPageBusinessData',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_APP_INFO: {
    url: '/xdap-app/application/query/applicationInfo',
    method: 'get',
    disableSuccessMsg: true
  },
  APP_ENGINE_HOME_GET_MENU_TREE: {
    url: '/xdap-app/menu/query/appMenu',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_LIST_PAGE_BUTTON: {
    url: '/xdap-app/form/query/listPageButton',
    method: 'get',
    disableSuccessMsg: true
  },
  DETAIL_PAGE_CONFIG_BY_ID: {
    url: '/xdap-app/form/query/formConfigAndStatus',
    method: 'get',
    disableSuccessMsg: true
  },
  DETAIL_PAGE_GET_BUSINESS_DATA: {
    url: '/xdap-app/business/query/detailBusinessData',
    method: 'get',
    disableSuccessMsg: true
  },
  // 请求模板表单数据
  DETAIL_PAGE_GET_TEMPLATE_DATA: {
    url: '/xdap-app/dataModule/query/dataModule',
    method: 'GET',
    disableSuccessMsg: true
  },
  DETAIL_PAGE_GET_TABLE_BUSINESS_DATA: {
    url: '/xdap-app/business/query/detailTableBusinessData',
    method: 'get',
    disableSuccessMsg: true
  },
  DETAIL_PAGE_GET_FORM_BUTTON: {
    url: '/xdap-app/form/query/formButton',
    method: 'get',
    disableSuccessMsg: true
  },
  DETAIL_PAGE_GET_DETAIL_FORM_BUTTON: {
    url: '/xdap-app/form/query/detailFormButton',
    method: 'get',
    disableSuccessMsg: true
  },
  DETAIL_PAGE_SUBMIT_BUSINESS_DATA: {
    url: '/xdap-app/business/save/businessData',
    method: 'post'
  },
  DETAIL_PAGE_TEMPSAVE_BUSINESS_DATA: {
    url: '/xdap-app/business/tempSave',
    method: 'post'
  },
  DETAIL_PAGE_PROCESS_SUBMIT: {
    url: '/xdap-app/process/submit',
    method: 'post'
  },
  DO_RESTART: {
    url: '/xdap-app/process/restart',
    method: 'post'
  },
  DO_APPROVE: {
    url: '/xdap-app/process/approve',
    method: 'post'
  },
  DO_CUSTOM_PROCESS: {
    url: '/xdap-app/process/customFlow',
    method: 'post'
  },
  DO_REJECT: {
    url: '/xdap-app/process/reject',
    method: 'post'
  },
  DO_WITHDRAW: {
    url: '/xdap-app/process/withdraw',
    method: 'post'
  },
  DO_DELETE: {
    url: '/xdap-app/business/delete/form',
    method: 'get'
  },
  DO_INQUIRE: {
    url: '/xdap-app/process/inquire',
    method: 'post'
  },
  DO_REASSIGN: {
    url: '/xdap-app/process/reassign',
    method: 'post'
  },
  DO_REPLY: {
    url: '/xdap-app/process/reply',
    method: 'post'
  },
  DO_ADDONE: {
    url: '/xdap-app/process/addOne',
    method: 'post'
  },
  QUERY_DEPARTMENT_INFO: {
    url: '/xdap-app/user/select/queryChildDept',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_ALL_USERS: {
    url: '/xdap-app/user/select/queryAllUsers',
    method: 'post',
    disableSuccessMsg: true
  },
  // 通过数据过滤后的人员
  QUERY_ALL_USERS_FILTER: {
    url: '/xdap-app/user/select/queryAllUsersFilter',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_CHILD_DEPT_AND_USER: {
    url: '/xdap-app/user/mobile/select/queryChildDeptAndUser',
    method: 'get',
    disableSuccessMsg: true
  },
  ADD_MENU_COLLECT: {
    url: '/xdap-app/menu/add/star',
    method: 'post'
  },
  REMOVE_MENU_COLLECT: {
    url: '/xdap-app/menu/remove/star',
    method: 'post'
  },
  HAS_MENU_COLLECT: {
    url: '/xdap-app/menu/has/menuStar',
    method: 'post',
    disableSuccessMsg: true
  },
  // 请求模板列表
  QUERY_DATA_TEMPLATE_LIST: {
    url: '/xdap-app/dataModule/query/dataModules',
    method: 'post',
    disableSuccessMsg: true
  },
  // 查询数据模板数量
  QUERY_DATA_TEMPLATE_COUNT: {
    url: '/xdap-app/dataModule/query/userDataModuleCount',
    method: 'get',
    disableSuccessMsg: true
  },
  // 评论
  QUERY_RECORD_COMMENT: {
    url: '/xdap-app/business/query/businessDataComment',
    method: 'post',
    disableSuccessMsg: true
  },
  COMMENT_RECORD: {
    url: '/xdap-app/business/comment/businessData',
    method: 'post',
    disableSuccessMsg: true
  }
}
